import { useContext, useEffect } from "react"
import { Col, Form, Row } from "react-bootstrap"
import PickingContext from "../../context/pickingContext"
import ModalComponent from "../ModalComponent"
import { useCookies } from 'react-cookie'
import Swal from 'sweetalert2'

function ModalAssignOrderNumberEgreso({ currentPicking, setCurrentPicking }) {

    const { pendingOrders = [], setPendingOrders, linesForDocumentLines = {}, setLinesForDocumentLines } = useContext(PickingContext)

    console.log("file: ModalAssignOrderNumberEgreso.js ~ line 11 ~ linesForDocumentLines", linesForDocumentLines)

    const [cookies] = useCookies()
    const handleCloseModal = () => {
        const existSelectedPendingOrders = pendingOrders.filter(({ NroSolicitud, DocEntry, ItemCode }) => `${NroSolicitud}-${DocEntry}-${ItemCode}` in linesForDocumentLines)
        if (existSelectedPendingOrders.length > 0) {
            let cantidad = 0
            pendingOrders.map(({ NroSolicitud, DocEntry, ItemCode }) => {
                if (`${NroSolicitud}-${DocEntry}-${ItemCode}` in linesForDocumentLines) {
                    if (linesForDocumentLines[`${NroSolicitud}-${DocEntry}-${ItemCode}`].Quantity == 0) {
                        Swal.fire({
                            icon: "error",
                            title: "Acción denegada",
                            text: "No se puede asignar valor 0"
                        })
                        return
                    } else cantidad += linesForDocumentLines[`${NroSolicitud}-${DocEntry}-${ItemCode}`].Quantity
                }
            })
            if (cantidad === currentPicking.articlePending) {
                setPendingOrders([])
                setCurrentPicking({})
            } else Swal.fire({
                icon: "error",
                title: "Acción denegada",
                text: "La cantidad a ingresar debe ser igual a la del picking"
            })
        } else {
            setPendingOrders([])
            setCurrentPicking({})
        }
    }


    return (
        <ModalComponent
            modalIsVisible={pendingOrders.length > 0}
            handleClose={handleCloseModal}
            keyboard={false}
            showConfirmButton={false}
            backdrop="static"
            modalTitle="Seleccionar N° Solicitud de Traslado"
        >
            <Row className="justify-content-end m-2">
                <p className="mb-0"> Cant. Picking: <span className="font-weight-bold"> {currentPicking?.articleQuantity}</span></p>
            </Row>
            <Row>
                {
                    pendingOrders
                        .map(order => <Row key={order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode} className="border rounded my-1 mx-3 p-1 justify-content-between w-100 px-3 align-items-center">
                            <Col md={3} className="px-0">
                                <Row className="px-2">
                                    {pendingOrders.length > 1 && <Form.Check
                                        inline
                                        type="checkbox"
                                        onClick={e => {
                                            if (linesForDocumentLines[Object.keys(linesForDocumentLines).filter(val => val).shift()]?? order.ItemCode) {
                                                if (e.target.checked) {
                                                    setLinesForDocumentLines({
                                                        ...linesForDocumentLines,
                                                        [order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode]: {
                                                            ItemCode: order?.ItemCode,
                                                            Quantity: 0,
                                                            WarehouseCode: cookies?.BPLName,
                                                            ProjectCode: order?.Project,
                                                            BaseType: 1250000001,
                                                            BaseEntry: order?.DocEntry,
                                                            BaseLine: order?.LineNum,
                                                        }
                                                    })
                                                } else {
                                                    delete linesForDocumentLines?.[order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode]
                                                    setLinesForDocumentLines(linesForDocumentLines)
                                                }
                                            } else {
                                                if (Object.keys(linesForDocumentLines).length === 0) {
                                                    setLinesForDocumentLines({
                                                        ...linesForDocumentLines,
                                                        [order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode]: {
                                                            ItemCode: order?.ItemCode,
                                                            Quantity: 0,
                                                            WarehouseCode: cookies?.BPLName,
                                                            ProjectCode: order?.Project,
                                                            BaseType: 1250000001,

                                                            BaseEntry: order?.DocEntry,
                                                            BaseLine: order?.LineNum,
                                                        }
                                                    })
                                                } else {
                                                    e.preventDefault()
                                                }
                                            }
                                        }}
                                        
                                        checked={`${order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode}` in linesForDocumentLines}
                                    />}
                                    <p className="mb-0">N° : { order.NroSolicitud}</p>
                                </Row>
                            </Col>
                            <Col md={3} className="px-0">
                                <p className="mb-0">Cant. Pendiente: {order.OpenQty}</p>
                            </Col>
                           
                            {
                                pendingOrders.length === 1 ?
                                    <p className="mb-0">Cant. a Egresar: {currentPicking?.articleQuantity}</p>
                                    :
                                    <Col md={2} className="px-0">
                                        <Form.Control
                                            size="sm"
                                            placeholder="Asignar Cantidad"
                                            value={linesForDocumentLines?.[order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode]?.Quantity ?? 0}
                                            disabled={!(!!linesForDocumentLines?.[order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode])}
                                            onChange={e => {
                                                if ([order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode] in linesForDocumentLines) {
                                                    const selectedOrder = pendingOrders?.filter(({ NroSolicitud }) => NroSolicitud === order.NroSolicitud )
                                                    if (selectedOrder?.[0]?.OpenQty < Number(e.target.value)) {
                                                        e.preventDefault()
                                                        Swal.fire({
                                                            icon: "warning",
                                                            title: "Acción denegada",
                                                            text: "No puedes ingresar un valor mayor a la cantidad Pendiente"
                                                        })
                                                    } else {
                                                        linesForDocumentLines[order.NroSolicitud + "-" + order.DocEntry + '-' + order.ItemCode].Quantity = Number(e.target.value)
                                                    }

                                                }
                                                setLinesForDocumentLines(linesForDocumentLines)
                                            }}
                                            onKeyPress={e => {
                                                if (e.code.includes('Key') && e.ctrlKey === false) return e.preventDefault()
                                            }
                                            }
                                        />
                                    </Col>
                            }

                        </Row>
                        )
                }
                {
                    pendingOrders.length === 0 && <div className="w-100"><p className="mb-0 text-center">No hay datos que mostrar</p></div>
                }
            </Row>
        </ModalComponent>
    )
}

export default ModalAssignOrderNumberEgreso